import { Point } from 'slate';
import getPointFromTextsSnapshot from './getPointFromTextsSnapshot';
export default function getPointFromCursor(editor, textsSnapshot, _ref) {
  var block = _ref.block,
      offset = _ref.offset;

  if (block) {
    // We need up-to-date block after all temporary cursors have been deleted
    block = editor.value.document.getNode(block.key);
    var text = block.getTextAtOffset(offset);
    return Point.create({
      key: text.key,
      offset: offset - block.getOffset(text.key)
    }).normalize(editor.value.document);
  } else {
    return getPointFromTextsSnapshot(editor, textsSnapshot);
  }
}